(() => {
  const LinkedProductsSku = window.LinkedProductsSku;

  if (!LinkedProductsSku) {
    return;
  }

  const state = {
    frame: null,
    observer: null
  };

  const renderQuickCartLinkedProducts = () => {
    if (!Array.isArray(window.products)) {
      return;
    }

    document.querySelectorAll('quick-cart-drawer [data-linked-products-sku]').forEach(container => {
      const productRoot = container.closest('[data-product-id]');
      const productId = Number(productRoot?.dataset.productId);
      const currentProduct = window.products.find(product => product.id === productId);

      if (!currentProduct) {
        container.innerHTML = '';
        return;
      }

      const linkedProducts = LinkedProductsSku.getLinkedProducts(window.products, currentProduct.sku);
      const currentColorElem = container.closest('.linked-products-block')?.querySelector('[data-current-color]')
        || productRoot?.querySelector('[data-current-color]');

      if (!linkedProducts.length) {
        container.innerHTML = '';
        return;
      }

      const activeLinked = linkedProducts.find(linked => linked.sku === currentProduct.sku);
      const markup = linkedProducts.map(linked => {
        const color = LinkedProductsSku.getColorLabel(linked.title);
        return `
          <a href="${linked.url}" class="${linked.sku === activeLinked?.sku ? 'active' : ''} ${!linked.available ? 'unavailable' : ''}" data-color="${color}">
            <img src="${linked.image}" alt="${linked.title}">
          </a>
        `;
      }).join('');

      if (container.innerHTML !== markup) {
        container.innerHTML = markup;
      }

      if (currentColorElem && activeLinked) {
        currentColorElem.textContent = LinkedProductsSku.getColorLabel(activeLinked.title);
      }
    });
  };

  const queueRender = () => LinkedProductsSku.queueRender(state, renderQuickCartLinkedProducts);

  const init = async () => {
    const drawer = document.querySelector('quick-cart-drawer');
    if (!drawer) {
      return;
    }

    LinkedProductsSku.observeMutations({
      root: drawer,
      state,
      selectors: ['.quick-cart-product', '[data-linked-products-sku]', '[data-product-id]'],
      onChange: queueRender
    });

    if (!LinkedProductsSku.getStoredProducts()) {
      await LinkedProductsSku.fetchAllProducts();
    } else {
      window.products = LinkedProductsSku.getStoredProducts();
    }

    queueRender();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
